import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import { EllipsisHorizontalIcon } from '@heroicons/react/16/solid';
import { IBreadcrumbItem } from './breadcrumbs';

import { useTranslation } from 'react-i18next';

export function MobileBreadCrumb({
  navigation,
}: {
  navigation: IBreadcrumbItem[];
}) {
  const { t } = useTranslation('designSystem');
  return (
    <Menu as="div" className="flex">
      <Menu.Button
        className="text-content-muted inline-flex items-center rounded-md px-1.5 py-0.5 hover:bg-black/5 hover:text-gray-900 focus-visible:ring-2 focus-visible:ring-gray-600 focus-visible:outline-none focus-visible:ring-inset dark:hover:bg-white/10 dark:hover:text-gray-100 dark:focus-visible:ring-gray-400"
        aria-label={t('showMoreBreadcrumbs')}
      >
        <EllipsisHorizontalIcon
          className="size-4 shrink-0"
          aria-hidden="true"
        />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute top-full left-0 z-10 w-56 origin-top-left rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black/5 focus:outline-none dark:bg-gray-900 dark:ring-gray-600">
          {navigation.map((item, index) => (
            <Menu.Item key={index} disabled={!item.to}>
              {({ active }) =>
                item.to ? (
                  <Link
                    className={`${active ? 'bg-black/5 text-gray-900 dark:bg-white/10 dark:text-gray-100' : 'text-content-muted'} block truncate px-4 py-2`}
                    to={item.to}
                  >
                    {item.name}
                  </Link>
                ) : (
                  <span className="text-content-muted block truncate px-4 py-2">
                    {item.name}
                  </span>
                )
              }
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
